import { IconSvgPaths16 } from "@blueprintjs/icons";
import { GridOptions } from "ag-grid-community";

const ICON_SIZE = 12;
const VIEW_BOX_SIZE = 16;

const toSvg = (paths: ReadonlyArray<string>): string =>
    `<svg viewBox="0 0 ${VIEW_BOX_SIZE} ${VIEW_BOX_SIZE}" width="${ICON_SIZE}" height="${ICON_SIZE}" fill="currentColor" aria-hidden="true">${paths
        .map((d) => `<path d="${d}"></path>`)
        .join("")}</svg>`;

export const BLUEPRINT_SORT_ICONS: GridOptions["icons"] = {
    sortAscending: () => toSvg(IconSvgPaths16.CaretUp),
    sortDescending: () => toSvg(IconSvgPaths16.CaretDown),
    sortUnSort: () => toSvg(IconSvgPaths16.DoubleCaretVertical)
};
